export default "__VITE_ASSET__31cb1f93__"